import React, {
  Component
} from 'react';
import { Bar } from 'react-chartjs-2';

class FamilyCapacityView extends Component {

  getGraphData = (dataObj, dataObjConfirmed) => {
    let data = {
      labels: [],
      datasets: [
        {
          label: 'Not Confirmed',
          backgroundColor: [],
          hoverBackgroundColor: [],
          data: []
        },
        {
          label: 'Confirmed',
          backgroundColor: [],
          hoverBackgroundColor: [],
          data: []
        }
      ]
    };

    if(Object.keys(dataObj).length) {
      const maxNum = Math.max.apply(null, Object.keys(dataObj));
      const minNum = Math.min.apply(null, Object.keys(dataObj));
      for (var i = minNum; i <= maxNum; i++) {
        const numbers = dataObj[i] ? dataObj[i] : 0;
        const confirmNumbers = dataObjConfirmed[i] ? dataObjConfirmed[i] : 0;
        if(numbers > 0 || confirmNumbers > 0) {
          let label = (i>12?i-12:i)+ (i<12?"AM":"PM") +'-'+ ((i+1)>12?(i+1)-12:(i+1))+ ((i+1)<12?"AM":"PM");
          data.labels.push(label);
          data.datasets[0]['data'].push((numbers >= confirmNumbers) ? (numbers-confirmNumbers) : numbers );
          // data.datasets[0]['data'].push(2);
          data.datasets[0]['backgroundColor'].push("#428a9d");
          data.datasets[0]['hoverBackgroundColor'].push("#4ec4e4");
          data.datasets[1]['data'].push(confirmNumbers);
          // data.datasets[1]['data'].push(3);
          data.datasets[1]['backgroundColor'].push("#EECEAF");
          data.datasets[1]['hoverBackgroundColor'].push("#FF952E");
        }
      }
      data.datasets[0]['data'].push(0);
      data.datasets[1]['data'].push(0);
    }
    return data;
  }

  render() {
    const { tableData } = this.props;
    const dataArray = tableData.reportData;
    const data = this.getGraphData(tableData.orderByTime, tableData.orderByTimeConfirmed);
    let totalAppt = { confirmed: 0, notConfirmed: 0 }
    return (
      <div>
        { (tableData.doctors.otherDoctors && tableData.doctors.otherDoctors.length)
          ?
            <div className="doctorList"><h3>Available Doctors</h3><p>
              {
                tableData.doctors.otherDoctors.join(', ')
              }
            </p></div>
          : ""
        }
        <table className="table tableCustomStyle">
          <thead><tr><th>APPTS</th><th>CONFIRMED</th><th>ALL APPTS</th></tr></thead>
          <tbody>
            {
              Object.keys(dataArray).length && Object.keys(dataArray).map( key =>
                <tr key={key}>
                  <td>{key}</td>
                  <td className="primaryColor cursorPointer" onClick={()=>this.props.openNextDays({ confirmed: true, type: key, heading: `Confirmed ${key} "${dataArray[key].confirmed}"`})}>{dataArray[key].confirmed}</td>
                  <td className="primaryColor cursorPointer" onClick={()=>this.props.openNextDays({ confirmed: false, type: key, heading: `${key} "${dataArray[key].total}"`})}>{dataArray[key].total}</td>
                </tr>
              )
            }
          </tbody>
        </table>
        <div className="container-fluid">
        <div className="row mt20">
          <div className="col-12 col-sm-12 col-md-8 pb-3">
            <Bar data={data} width={10} height={280}
              options={{
                maintainAspectRatio: false,
                className:"mb20",
                scales: {
                 xAxes: [{ stacked: true }],
                 yAxes: [{ stacked: true }]
                }
              }}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-4 mb20">
            <table className="table tableCustomStyle">
              <thead><tr><th title="Appointment Time">TIME</th><th className="text-center" title="Confirmed Appointments">Conf</th><th title="Not Confirmed Appointments" className="text-right">Not Conf</th></tr></thead>
              <tbody>
                {
                  data.labels.length ?
                    data.labels.map((label, i) => {
                      totalAppt['confirmed'] += parseInt(data.datasets[1]['data'][i]);
                      totalAppt['notConfirmed'] += parseInt(data.datasets[0]['data'][i]);
                      return (<tr key={i}>
                        <td>{label}</td>
                        <td className="text-center">{data.datasets[1]['data'][i]}</td>
                        <td className="text-right">{data.datasets[0]['data'][i]}</td>
                      </tr>)
                    })
                  :
                  <tr><td colSpan="3">No Record Found</td></tr>
                }
                { (totalAppt['confirmed'] > 0 || totalAppt['notConfirmed'] > 0) ?
                  <tr key="total">
                    <td><strong>Total:</strong> </td>
                    <td className="text-center"><strong>{totalAppt['confirmed']}</strong></td>
                    <td className="text-right"><strong>{totalAppt['notConfirmed']}</strong></td>
                  </tr>
                 : "" }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
    )
  }
}

export default FamilyCapacityView;
